module.exports = __webpack_public_path__ + "img/SC5-future-income.80e14254.svg";